import * as types from './types'

export const actions = {
	toggleLoading: (payload) => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: (payload) => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	toggleError: (payload) => ({
		type: types.TOGGLE_ERROR,
		payload,
	}),
	setStaffProject: (payload) => ({
		type: types.SET_STAFF_PROJECT,
		payload,
	}),
	addOpenedChildId: (payload) => ({
		type: types.ADD_OPENED_CHILD_ID,
		payload,
	}),
	removeOpenedChildId: (payload) => ({
		type: types.REMOVE_OPENED_CHILD_ID,
		payload,
	}),
	setStaffXml: (payload) => ({
		type: types.SET_STAFF_XML,
		payload,
	}),
	setStatus: (payload) => ({
		type: types.SET_STATUS,
		payload,
	}),


	getPositionByDeptType: (payload) => ({
		type: types.GET_POSITION_DEPT_TYPE,
		payload,
	}),
	getPositionByDeptTypeDone: (payload) => ({
		type: types.GET_POSITION_DEPT_TYPE_DONE,
		payload,
	}),
	getPositionByDeptTypeFail: (payload) => ({
		type: types.GET_POSITION_DEPT_TYPE_FAIL,
		payload,
	}),


	getStaffExperience: (payload) => ({
		type: types.GET_STAFF_EXPERIENCE,
		payload,
	}),
	getStaffExperienceDone: (payload) => ({
		type: types.GET_STAFF_EXPERIENCE_DONE,
		payload,
	}),
	getStaffExperienceFail: (payload) => ({
		type: types.GET_STAFF_EXPERIENCE_FAIL,
		payload,
	}),

	getStaffUnit: (payload) => ({
		type: types.GET_STAFF_UNIT,
		payload,
	}),
	getStaffUnitDone: (payload) => ({
		type: types.GET_STAFF_UNIT_DONE,
		payload,
	}),
	getStaffUnitFail: (payload) => ({
		type: types.GET_STAFF_UNIT_FAIL,
		payload,
	}),

	getStaffLevel: (payload) => ({
		type: types.GET_STAFF_LEVEL,
		payload,
	}),
	getStaffLevelDone: (payload) => ({
		type: types.GET_STAFF_LEVEL_DONE,
		payload,
	}),
	getStaffLevelFail: (payload) => ({
		type: types.GET_STAFF_LEVEL_FAIL,
		payload,
	}),
}
